/* Quidmart Premium Redesign JS: minimal safe helpers only. */
(function(){
  'use strict';

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function currentNavUnderline(){
    var links = document.querySelectorAll('.tt-desctop-menu a[href]');
    Array.prototype.forEach.call(links, function(link){
      var href = link.getAttribute('href');
      if(!href || href === '/' || href.charAt(0) === '#') return;
      try{
        var path = href.replace(location.origin, '').split('?')[0];
        if(path && path !== '/' && location.pathname.indexOf(path) === 0){
          link.classList.add('qm-current-link');
        }
      }catch(e){}
    });
  }

  function improveSearchPlaceholder(){
    var inputs = document.querySelectorAll('input[type="search"], .tt-search-input');
    Array.prototype.forEach.call(inputs, function(input){
      if(!input.getAttribute('placeholder')) input.setAttribute('placeholder', 'Search products...');
    });
  }

  function stabilizeMobileSearchOpen(){
    document.addEventListener('click', function(event){
      if(window.innerWidth > 768) return;

      var toggle = event.target.closest('header .tt-mobile-parent-search .tt-dropdown-toggle');
      if(toggle){
        var search = toggle.closest('.tt-search');
        var input = search ? search.querySelector('.tt-search-input') : null;
        if(search && input){
          document.body.classList.add('tt-open-search');
          document.body.classList.remove('tt-popup-dropdown');
          search.classList.add('active');
          window.setTimeout(function(){ input.focus(); }, 30);
        }
        return;
      }

      var close = event.target.closest('header .tt-mobile-parent-search .tt-btn-close');
      if(close){
        var activeSearch = close.closest('.tt-search');
        if(activeSearch) activeSearch.classList.remove('active');
        document.body.classList.remove('tt-open-search');
      }
    }, true);
  }

  function nativeMobileSearch(){
    document.addEventListener('click', function(event){
      if(window.innerWidth > 768) return;

      var toggle = event.target.closest('.qm-mobile-search-native-toggle');
      if(toggle){
        var header = toggle.closest('.tt-mobile-header');
        var panel = header ? header.querySelector('.qm-mobile-search-native-panel') : null;
        var input = panel ? panel.querySelector('.qm-mobile-search-native-input') : null;
        if(panel){
          panel.hidden = false;
          document.body.classList.add('qm-mobile-search-native-open');
          toggle.setAttribute('aria-expanded', 'true');
          window.setTimeout(function(){ if(input) input.focus(); }, 30);
        }
        event.preventDefault();
        return;
      }

      var close = event.target.closest('.qm-mobile-search-native-close');
      if(close){
        var closePanel = close.closest('.qm-mobile-search-native-panel');
        var closeHeader = close.closest('.tt-mobile-header');
        var closeToggle = closeHeader ? closeHeader.querySelector('.qm-mobile-search-native-toggle') : null;
        if(closePanel) closePanel.hidden = true;
        if(closeToggle) closeToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('qm-mobile-search-native-open');
        event.preventDefault();
      }
    }, true);
  }

  function enhanceMobileMenuButton(){
    var toggle = document.querySelector('.qm-mobile-menu-toggle');
    var nav = document.getElementById('qm-mobile-navigation');
    if(!toggle || !nav) return;
    toggle.setAttribute('aria-controls', 'qm-mobile-navigation');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-haspopup', 'true');
    toggle.addEventListener('keydown', function(event){
      if(event.key === 'Enter' || event.key === ' '){
        event.preventDefault();
        toggle.click();
      }
    });
  }

  ready(function(){
    document.documentElement.classList.add('qm-premium-ready');
    currentNavUnderline();
    improveSearchPlaceholder();
    stabilizeMobileSearchOpen();
    nativeMobileSearch();
    enhanceMobileMenuButton();
  });
})();

/* Lightweight mobile mini-cart portal. Previous duplicate positioning and force-open observers were removed to avoid continuous layout work. */
/* Lightweight mobile mini-cart portal.
   On small screens the theme moves .tt-cart between several header containers. Some of
   those ancestors create clipping/stacking contexts, so the backdrop can appear while
   the dropdown itself remains hidden. Portal only the dropdown panel to <body> while
   open, then restore it to the cart on close. Desktop is untouched. */
(function () {
  'use strict';

  var placeholder = null;
  var activeCart = null;
  var activeMenu = null;
  var closeTimer = 0;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function getCartFromToggle(toggle) {
    return toggle ? toggle.closest('.tt-cart') : null;
  }

  function calculateTop() {
    var header = document.querySelector('header');
    if (!header) return 0;

    var bottom = 0;
    var visibleHeaders = header.querySelectorAll('.tt-mobile-header');
    for (var i = 0; i < visibleHeaders.length; i += 1) {
      var node = visibleHeaders[i];
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if (style.display === 'none' || style.visibility === 'hidden' || rect.height <= 0) continue;
      if (rect.bottom > bottom && rect.bottom <= window.innerHeight) bottom = rect.bottom;
    }

    var searchPanel = header.querySelector('.qm-mobile-search-native-panel');
    if (searchPanel) {
      var searchStyle = window.getComputedStyle(searchPanel);
      var searchRect = searchPanel.getBoundingClientRect();
      if (searchStyle.display !== 'none' && searchStyle.visibility !== 'hidden' && searchRect.height > 0) {
        bottom = Math.max(bottom, searchRect.bottom);
      }
    }

    if (!bottom) bottom = header.getBoundingClientRect().bottom;
    return Math.max(0, Math.min(Math.ceil(bottom), window.innerHeight - 120));
  }

  function portalOpen(cart) {
    if (!isMobile() || !cart) return;

    var menu = cart.querySelector(':scope > .tt-dropdown-menu');
    if (!menu) menu = cart.querySelector('.tt-dropdown-menu');
    if (!menu) return;

    if (activeMenu && activeMenu !== menu) portalClose();

    activeCart = cart;
    activeMenu = menu;

    if (!placeholder) {
      placeholder = document.createComment('qm-mobile-cart-menu-placeholder');
      menu.parentNode.insertBefore(placeholder, menu);
    }

    if (menu.parentNode !== document.body) document.body.appendChild(menu);

    var top = calculateTop();
    menu.style.setProperty('--qm-mobile-cart-portal-top', top + 'px');
    menu.classList.add('qm-mobile-cart-portal');
    menu.classList.toggle('qm-mobile-cart-has-items', cart.classList.contains('tt-cart-has-items'));
    menu.classList.toggle('qm-mobile-cart-is-empty', cart.classList.contains('tt-cart-is-empty'));
    cart.classList.add('active', 'activetoview');
    document.body.classList.add('tt-popup-dropdown', 'qm-mobile-cart-portal-open');

    window.clearTimeout(closeTimer);
  }

  function portalClose() {
    window.clearTimeout(closeTimer);

    if (activeMenu) {
      activeMenu.classList.remove('qm-mobile-cart-portal', 'qm-mobile-cart-has-items', 'qm-mobile-cart-is-empty');
      activeMenu.style.removeProperty('--qm-mobile-cart-portal-top');

      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(activeMenu, placeholder);
        placeholder.parentNode.removeChild(placeholder);
      }
    }

    if (activeCart) activeCart.classList.remove('active', 'activetoview');

    document.body.classList.remove('qm-mobile-cart-portal-open', 'qm-mobile-cart-force-open');
    activeMenu = null;
    activeCart = null;
    placeholder = null;
  }

  function scheduleOpen(cart) {
    window.requestAnimationFrame(function () { portalOpen(cart); });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('header .tt-cart .tt-dropdown-toggle');
    if (toggle && isMobile()) {
      var cart = getCartFromToggle(toggle);
      scheduleOpen(cart);
      return;
    }

    if (event.target.closest('.qm-mobile-cart-portal .tt-close, .header-popup-bg')) {
      closeTimer = window.setTimeout(portalClose, 0);
    }
  }, true);

  document.addEventListener('mouseup', function (event) {
    if (event.target.closest('.qm-mobile-cart-portal')) {
      event.stopPropagation();
    }
  }, true);

  window.addEventListener('resize', function () {
    if (!isMobile()) {
      portalClose();
      return;
    }
    if (activeMenu) {
      activeMenu.style.setProperty('--qm-mobile-cart-portal-top', calculateTop() + 'px');
    }
  }, { passive: true });

  window.addEventListener('orientationchange', function () {
    if (activeMenu) {
      window.setTimeout(function () {
        activeMenu.style.setProperty('--qm-mobile-cart-portal-top', calculateTop() + 'px');
      }, 120);
    }
  }, { passive: true });
})();
